/* ---------------------------------------------------------------
   SIGNAL HISTORY timestamp formatting — real data comes from the
   backend's auth/register response as `stats`:
   [{ id, asset, profit, source, created_at }]. `created_at` is an
   ISO timestamp localized here for the profile's history list.
------------------------------------------------------------------ */
export const LOCALE_BY_LANG = { uk: "uk-UA", ru: "ru-RU", en: "en-US" };

/* "today"/"yesterday" get translated labels via t.prof_today /
   t.prof_yesterday at render time; anything older falls back to a
   locale-formatted short date (already localized here, not a t.* key). */
export function formatHistoryTimestamp(iso, lang) {
  const date = new Date(iso);
  const now = new Date();
  const locale = LOCALE_BY_LANG[lang] || "en-US";
  const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diffDays = Math.round((startOfDay(now) - startOfDay(date)) / 86400000);

  const time = date.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit", hour12: false });
  let dayLabel;
  if (diffDays === 0) dayLabel = "today";
  else if (diffDays === 1) dayLabel = "yesterday";
  else dayLabel = date.toLocaleDateString(locale, { day: "2-digit", month: "2-digit" });

  return { time, dayLabel };
}

/* ---------------------------------------------------------------
   SIGNAL COUNTDOWN — the Signals/Scanner bots now return a Forex-style
   "timeframe" string (e.g. "M15", "H1", "H4") instead of a raw
   time_seconds duration. ActiveSignalOverlay still drives its
   countdown off an absolute deadline, so this converts whatever the
   backend sent into seconds. Accepts "M15"/"H1"/"15m"/"1h" style
   codes case-insensitively (prefix or suffix letter, either order);
   falls back to `fallbackSeconds` (default 15 minutes) for anything
   it doesn't recognise rather than crashing the countdown.
------------------------------------------------------------------ */
export function timeframeToSeconds(timeframe, fallbackSeconds = 15 * 60) {
  if (!timeframe || typeof timeframe !== "string") return fallbackSeconds;
  const match = timeframe.trim().match(/^([A-Za-z]*)(\d+)\s*([A-Za-z]*)$/);
  if (!match) return fallbackSeconds;
  const [, prefix, numStr, suffix] = match;
  const n = parseInt(numStr, 10);
  if (!n) return fallbackSeconds;
  const unit = (prefix || suffix || "m").toLowerCase();
  if (unit.startsWith("s")) return n;
  if (unit.startsWith("h")) return n * 3600;
  if (unit.startsWith("d")) return n * 86400;
  return n * 60; // "m"/"min" and anything unrecognised defaults to minutes
}